import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';

import EmployerJobCard from '../EmployerJobCard';

const RolesTab = ({
    company,
    jobSections,
    user,
    subRoleCount,
    showJobs,
    setJobOpen,
    selectedTab,
    handleTabChange
}: {
    company: any;
    jobSections: any;
    user: any;
    subRoleCount: number;
    showJobs: any;
    setJobOpen: (jobID: number, open: boolean) => void;
    selectedTab: 'active' | 'pending' | 'completed';
    handleTabChange: (
        event: React.SyntheticEvent,
        newValue: 'active' | 'pending' | 'completed'
    ) => void;
}) => (
    <>
        <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            aria-label={`${company?.name} Job sections`}
            style={{ marginBottom: '1rem' }}
        >
            {Object.keys(jobSections).map((section) => (
                <Tab
                    key={section}
                    label={
                        jobSections[section as keyof typeof jobSections].title
                    }
                    value={section}
                />
            ))}
        </Tabs>
        {(
            [
                'active',
                'pending',
                'completed'
            ] as unknown as (keyof typeof jobSections)[]
        ).map((section) => (
            <>
                {jobSections[section].jobs
                    .slice(0, showJobs[section].jobs)
                    .map(
                        (job: any, index: number) =>
                            selectedTab === section && (
                                <EmployerJobCard
                                    key={index}
                                    job={job}
                                    userID={user.userID}
                                    active={!!company.subscription}
                                    status={
                                        section === 'completed' && !job.open
                                            ? 'closed'
                                            : section
                                    }
                                    setJobOpen={(open: boolean) =>
                                        setJobOpen(job.id, open)
                                    }
                                    activeRolesExceeded={
                                        subRoleCount <=
                                        jobSections.active.jobs.length
                                    }
                                />
                            )
                    )}
            </>
        ))}
    </>
);

export default RolesTab;
